import axios from "axios";
import { baseUrlNew, buildAuthHeaders } from "./config";

export const fetchSignUpData = function (params) {
  return axios.post(`${baseUrlNew}/users/signup`, params, {
    headers: buildAuthHeaders(),
    withCredentials: true,
  });
};

export const fetchSignInData = function (params) {
  return axios.post(`${baseUrlNew}/users/signin`, params, {
    headers: buildAuthHeaders(),
    withCredentials: true,
  });
};